import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import PCFooter from "./PCLayouts/Footer/index";
import PCHeader from "./PCLayouts/Header/index";
import MobileHeader from "./MobileLayouts/Header";
import MobileFooter from "./MobileLayouts/Footer";
import { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { FloatButton } from "antd";
import "./index.less";
import Loading from "@src/Basic/Loading";
import { resetViewport } from "@src/Utils/CommonUtils";

const CNMain = () => {
  const { pathname, hash, state } = useLocation();
  const [isShowFixedHeader, setIsShowFixedHeader] = useState<boolean>(true);
  const contentRef = useRef<any>(null);
  const isHomeRef = useRef<boolean>(false);

  useEffect(() => {
    if (!hash) {
      contentRef.current.scrollTop = 0;
    }
  }, [pathname, hash]);

  const isHome = useMemo(() => {
    return pathname === "/home";
  }, [pathname]);

  const handleScroll = (e: any) => {
    if (isHomeRef.current) {
      setIsShowFixedHeader(!!e.target.scrollTop);
    }
  };

  useEffect(() => {
    if (isHome) {
      document.getElementById("pageContent")?.addEventListener("scroll", handleScroll);
    }
    setIsShowFixedHeader(!isHome);
    isHomeRef.current = isHome;
    return () => {
      document.getElementById("pageContent")?.removeEventListener("scroll", handleScroll);
    };
  }, [pathname, isHome]);

  useEffect(() => {
    if (isMobile) {
      // 移动端的下载页面
      resetViewport("width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
    } else {
      // 其他页面恢复正常缩放
      resetViewport("width=1440");
    }
  }, [isMobile]);

  return (
    <div
      className={`w-full h-full flex flex-col ${
        isMobile ? "MobilePageContent" : "PCPageContentWrap"
      }`}
    >
      <BrowserView>{isShowFixedHeader && <PCHeader />}</BrowserView>
      <MobileView>
        <MobileHeader />
      </MobileView>
      <div ref={contentRef} id="pageContent" className="overflow-x-hidden w-full">
        <BrowserView>
          {!isShowFixedHeader && (
            <div style={{ background: "#F1F4F9" }}>
              <PCHeader />
            </div>
          )}
        </BrowserView>
        <Suspense
          fallback={
            <>
              <Loading />
            </>
          }
        >
          <Outlet></Outlet>
        </Suspense>
        <BrowserView>
          <PCFooter />
        </BrowserView>
        <MobileView>
          <MobileFooter />
        </MobileView>
        <BrowserView>
          <FloatButton.BackTop visibilityHeight={1200} target={() => contentRef.current} />
        </BrowserView>
      </div>
    </div>
  );
};
export default CNMain;
